import React from 'react'
// import { PospLogin } from 'Pages';
import RegistrationStatus from 'Pages/Posp/RegistrationStatus'
import { Navigate, Route, Routes } from 'react-router-dom'
import PanVerification from 'Pages/Posp/PanVerification'
import DocumentUpload from 'Pages/Posp/DocumentUpload'
import GeneralInsurance from 'Pages/Posp/Examination/GeneralInsurance'
import TrainingModule from 'Pages/Posp/TrainingModule'
import PersonalDetails from 'Pages/Posp/PersonalDetails'
// import ProtectedRoute from 'Auth/ProtectedRoute';
import Register from 'Pages/Posp/Register'
import ProtectedRoute from 'Auth/ProtectedRoute'
import PospRegisteredStatus from 'Pages/Posp/PospRegisteredStatus'
import ExamInstruction from 'Pages/Posp/Examination/ExamInstruction'
import GeneralExamResultPage from 'Pages/Posp/Result'
import { useAppSelector } from 'app/hooks'
import Esign from 'Pages/Posp/Esign'

export const AppRouter: React.FC = () => {
  const { isLoggedIn } = useAppSelector((state) => state.user)
  return (
    <Routes>
      {/* <Route path="/" element={<PospLogin />} /> */}
      <Route path='/registration-status' element={<RegistrationStatus />} />
      {/* <Route path='/sp-registration/is-registered/status' element={<PospRegisteredStatus />} /> */}
      <Route
        path='/sp-registration/document-upload'
        element={
          // <ProtectedRoute state='doc_upload'>
          <DocumentUpload />
          // </ProtectedRoute>
        }
      />
      <Route
        path='/'
        element={isLoggedIn ? <Navigate to='/registration-status' /> : <Register />}
      />
      <Route
        path='/sp-registration/pan-verification'
        element={
          <ProtectedRoute state='pan_iib_verification'>
            <PanVerification />
          </ProtectedRoute>
        }
      />

      <Route
        path='/sp-registration/life-insurance-examination'
        element={
          <ProtectedRoute state='general_insu_exam'>
            <GeneralInsurance />
          </ProtectedRoute>
        }
      />
      <Route
        path='/sp-registration/life-insurance-examination/result'
        element={<GeneralExamResultPage />}
      />
      <Route
        path='/sp-registration/general-insurance-examination'
        element={
          <ProtectedRoute state='general_insu_exam'>
            <GeneralInsurance />
          </ProtectedRoute>
        }
      />
      <Route
        path='/sp-registration/general-insurance-examination/result'
        element={<GeneralExamResultPage />}
      />
      <Route
        path='/sp-registration/examination-instruction'
        element={
          <ProtectedRoute state='general_insu_exam'>
            <ExamInstruction />
          </ProtectedRoute>
        }
      />

      <Route
        path='/sp-registration/training'
        element={
          // <ProtectedRoute state='training_module'>
          <TrainingModule />
          // </ProtectedRoute>
        }
      />
      <Route
        path='/sp-registration/personal-details'
        element={
          <ProtectedRoute state='personal_details'>
            <PersonalDetails />
          </ProtectedRoute>
        }
      />
      <Route path='/esign/:uuid' element={<Esign />} />
    </Routes>
  )
}
